import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "pl-4 py-4"
};
const _hoisted_2 = {
  key: 1,
  class: "flex flex-col flex-1 w-full h-full bg-white"
};
import { storeToRefs } from 'pinia';
import { computed, onMounted, reactive, watch } from 'vue';
import { useInvoiceTemplateStore } from '@/services/useInvoiceTemplateStore.js';
import { useMeStore } from '@/services/UserService/useMeStore';

// components
import Loader from '@/components/Loader.vue';
import InvoiceTemplateListTable from '../InvoiceTemplateListTable.vue';
import UpdateInvoiceTemplateModal from '../InvoiceTemplate/UpdateInvoiceTemplateModal.vue';
import UpdateServiceExpenseByMatterPage from './UpdateServiceExpenseByMatterPage.vue';
import UpdateSettlementStatementTemplatePage from './UpdateSettlementStatementTemplatePage.vue';
export default {
  __name: 'InvoiceSummary',
  props: {
    alerts: {
      type: Object,
      required: true
    },
    leanLawApi: {
      type: Object,
      required: true
    },
    state: {
      type: Object,
      required: true
    },
    tracking: {
      type: Object,
      required: false
    }
  },
  setup(__props) {
    const props = __props;
    const invoiceTemplateStore = useInvoiceTemplateStore();
    invoiceTemplateStore.alerts = props.alerts;
    const {
      servicesAndExpenseTable
    } = storeToRefs(useInvoiceTemplateStore());
    const {
      features
    } = storeToRefs(useMeStore());
    const invoiceSummaryState = reactive({
      loading: false,
      showEditInvoiceTemplate: false,
      showServiceExpenseByMatterPage: false,
      showSettlementStatementTemplate: false,
      items: [{
        title: 'Edit',
        id: 'edit'
      }],
      selectedInvoiceTemplate: ''
    });
    const isSettlementStatementEnabled = computed(() => features.value?.settlementV2 && features.value?.leanlawInvoice);
    const isInvoiceSummaryEnabled = computed(() => features.value?.invoiceSummaryPage);
    const visibleOtherPageTemplates = computed(() => {
      const showSettlement = isSettlementStatementEnabled.value;
      const showInvoiceSummary = isInvoiceSummaryEnabled.value;
      return servicesAndExpenseTable.value.filter(template => {
        const isSettlementPage = template?.settlementStatementPage;

        // Both enabled: show all
        if (showSettlement && showInvoiceSummary) {
          return true;
        }
        // Only settlement enabled: show only settlement pages
        if (showSettlement && !showInvoiceSummary) {
          return isSettlementPage;
        }
        // Only invoice summary enabled: show only service/expense pages
        if (!showSettlement && showInvoiceSummary) {
          return !isSettlementPage;
        }
        // Neither enabled: show nothing
        return false;
      });
    });
    onMounted(async () => {
      fetchInvoiceTemplates();
    });

    // Load settlement template data when modal opens (lazy load)
    watch(() => invoiceSummaryState.showSettlementStatementTemplate, async isOpen => {
      if (isOpen && isSettlementStatementEnabled.value) {
        await invoiceTemplateStore.getSettlementStatementTemplate();
      }
    });
    const fetchInvoiceTemplates = async (reload = false) => {
      invoiceSummaryState.loading = true;
      try {
        await invoiceTemplateStore.getServicesAndExpensesSummaryTemplates(reload);
        if (features.value.indexPagePDF) await invoiceTemplateStore.getServicesAndExpenseByMatter(reload);
        if (isSettlementStatementEnabled.value) {
          await invoiceTemplateStore.getSettlementStatementTemplate(reload);
        }
      } catch (error) {
        props.alerts.error('Error fetching invoice templates');
      } finally {
        invoiceSummaryState.loading = false;
      }
    };
    const updateOtherTemplate = async (templateId, template) => {
      if (template?.settlementStatementPage) {
        invoiceSummaryState.showSettlementStatementTemplate = true;
        return;
      }
      if (template?.serviceExpenseByMatterPage) {
        invoiceSummaryState.showServiceExpenseByMatterPage = true;
        return;
      }
      invoiceSummaryState.showEditInvoiceTemplate = true;
      invoiceSummaryState.selectedInvoiceTemplate = templateId;
    };
    const closeModelAndFetchInvoiceTemplates = async reload => {
      invoiceSummaryState.showEditInvoiceTemplate = false;
      invoiceSummaryState.showServiceExpenseByMatterPage = false;
      invoiceSummaryState.showSettlementStatementTemplate = false;
      fetchInvoiceTemplates(reload);
    };
    const handleActionButtonClicked = async (action, invoiceTemplateId, invoiceTemplate) => {
      if (action === 'edit') {
        updateOtherTemplate(invoiceTemplateId, invoiceTemplate);
      }
    };
    return (_ctx, _cache) => {
      const _component_v_dialog = _resolveComponent("v-dialog");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [invoiceSummaryState.loading ? (_openBlock(), _createBlock(Loader, {
        key: 0,
        what: 'Other Pages',
        class: "mt-32"
      })) : (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_v_dialog, {
        modelValue: invoiceSummaryState.showEditInvoiceTemplate,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => invoiceSummaryState.showEditInvoiceTemplate = $event),
        class: "w-11/12"
      }, {
        default: _withCtx(() => [_createVNode(UpdateInvoiceTemplateModal, {
          alerts: __props.alerts,
          state: __props.state,
          tracking: __props.tracking,
          serviceExpensePage: true,
          leanLawAuth: _ctx.leanLawAuth,
          selectedInvoiceTemplate: invoiceSummaryState.selectedInvoiceTemplate,
          onCloseDialog: closeModelAndFetchInvoiceTemplates
        }, null, 8, ["alerts", "state", "tracking", "leanLawAuth", "selectedInvoiceTemplate"])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_v_dialog, {
        modelValue: invoiceSummaryState.showServiceExpenseByMatterPage,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => invoiceSummaryState.showServiceExpenseByMatterPage = $event),
        class: "w-11/12"
      }, {
        default: _withCtx(() => [_createVNode(UpdateServiceExpenseByMatterPage, {
          alerts: __props.alerts,
          onCloseDialog: closeModelAndFetchInvoiceTemplates
        }, null, 8, ["alerts"])]),
        _: 1
      }, 8, ["modelValue"]), _createVNode(_component_v_dialog, {
        modelValue: invoiceSummaryState.showSettlementStatementTemplate,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => invoiceSummaryState.showSettlementStatementTemplate = $event),
        class: "w-11/12"
      }, {
        default: _withCtx(() => [_createVNode(UpdateSettlementStatementTemplatePage, {
          alerts: __props.alerts,
          onCloseDialog: closeModelAndFetchInvoiceTemplates
        }, null, 8, ["alerts"])]),
        _: 1
      }, 8, ["modelValue"]), _cache[3] || (_cache[3] = _createElementVNode("div", {
        class: "flex justify-between pb-6"
      }, [_createElementVNode("div", {
        class: "w-10/12 pr-2"
      }, "Customize Your Other Pages.")], -1)), _createVNode(InvoiceTemplateListTable, {
        invoiceTemplateLists: visibleOtherPageTemplates.value,
        items: invoiceSummaryState.items,
        onUpdateInvoiceTemplate: updateOtherTemplate,
        onHandleActionButtonClicked: handleActionButtonClicked
      }, null, 8, ["invoiceTemplateLists", "items"])]))]);
    };
  }
};